var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`text-${_vm.breakpoint}-body-1`},[_c('b',[_vm._v("Биржевое время: ")]),_vm._v(" "+_vm._s(_vm.hour + ":" + _vm.minute + ":" + _vm.second + " | " + _vm.weekdays[_vm.day] + "," + new Date().getDate() + " " + _vm.yearmonth[_vm.month] + " " + new Date().getFullYear())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }